import {Send, MessageCircle, Mail} from 'lucide-react';
import {BRAND} from '@lib/brand';
import {BrandLockup} from '@ui/brand/GmkLogo';
import {ColverLogo} from '@ui/brand/ColverLogo';

/**
 * Глобальный футер приложения — лого, контакты, мессенджеры, ссылки на политики.
 * Монтируется в `AppLayout` один раз, виден на всех страницах.
 */
export const AppFooter = () => (
  <footer className='w-full mt-auto'>
    <div className='bg-[var(--color-surface)] border-t border-[var(--color-border)] px-4 md:px-6 py-3 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm'>
      {BRAND.motto ? (
        // Знак + слоган (как на визитке GMK: «ЭНЕРГИЯ ——— ДЕВЕЛОПМЕНТА»).
        <div className='flex items-center gap-4'>
          <BrandLockup height={16} />
          <span className='hidden lg:flex items-center gap-2 font-heading uppercase text-[10px] tracking-[0.06em] text-[var(--brand-gray-mid2)]'>
            {BRAND.motto[0]}
            <span className='w-10 border-t border-[var(--brand-gray-mid)]' />
            {BRAND.motto[1]}
          </span>
        </div>
      ) : (
        <div className='flex items-center gap-2.5'>
          <ColverLogo size={28} />
          <span className='font-medium text-[var(--color-foreground)]'>
            {BRAND.productName}
          </span>
        </div>
      )}

      {/* Контакты — только подписи: в демо ссылки не ведут наружу. */}
      <div className='flex flex-wrap items-center gap-x-4 gap-y-1 text-[var(--color-muted-foreground)]'>
        <span className='inline-flex items-center gap-1'>
          <Send size={14} />
          Telegram
        </span>
        <span className='inline-flex items-center gap-1'>
          <MessageCircle size={14} />
          Max
        </span>
        <span className='inline-flex items-center gap-1'>
          <Mail size={14} />
          Email
        </span>
      </div>

      {/* Политики */}
      <nav className='flex items-center gap-3 flex-wrap'>
        <a
          href='https://drive.google.com/file/d/1baPY64mj3EsLWQ4VrSdDpkCyC6kwOMYF/view?usp=sharing'
          target='_blank'
          rel='noopener noreferrer'
          className='text-[var(--color-muted-foreground)] hover:text-[var(--color-primary)]'
        >
          Политика конфиденциальности
        </a>
        <span className='text-[var(--color-border)]'>·</span>
        <a
          href='https://drive.google.com/file/d/1sqjxRxU2yPtR-cGJOREB_JlJny0iIzny/view?usp=sharing'
          target='_blank'
          rel='noopener noreferrer'
          className='text-[var(--color-muted-foreground)] hover:text-[var(--color-primary)]'
        >
          Политика использования cookie
        </a>
      </nav>
    </div>
  </footer>
);